module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.disable && _vm.visible) ? _c('div', {
    staticClass: "container",
    style: ({
      backgroundImage: 'url(static/bg.jpg)'
    })
  }, [_c('img', {
    staticClass: "logo1",
    attrs: {
      "src": "static/logoAC.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("福音TV")]), _vm._v(" "), _c('img', {
    staticClass: "logo2",
    attrs: {
      "src": "static/logo-icon.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.fytvapp.com/mobile/"
    }
  }, [_vm._v("点此下载 福音TV App观看")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("继续网页观看")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20de6c30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/welcome/index.vue
// module id = 310
// module chunks = 0